import { render, staticRenderFns } from "./PackageListingPageSettings.vue?vue&type=template&id=000d74cf"
import script from "./PackageListingPageSettings.vue?vue&type=script&lang=js"
export * from "./PackageListingPageSettings.vue?vue&type=script&lang=js"
import style0 from "./PackageListingPageSettings.vue?vue&type=style&index=0&id=000d74cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports